<div class="card navigation-menu-container">
    <!--div class="card d-flex justify-content-center"-->
    <!--div class="card flex justify-center navigation-menu-container"-->
    <p-menubar [model]="items">

        <ng-template pTemplate="start">
            <button
                type="button"
                class="logo-button"
                [attr.aria-label]="'redesign.header.LOGO_HOME' | translate"
                (click)="onClickLogo()">
                <img class="logo" [src]="logoImg" alt="" />
            </button>
        </ng-template>

        <ng-template pTemplate="end">

            <!-- Ein einziger Flex-Container fuer die gesamte rechte Gruppe, damit
                 Reihenfolge und Abstaende an EINER Stelle liegen – unabhaengig
                 davon, welche Elemente vorhanden sind (z. B. ohne Kundenlogo).
                 Die Rechtsbuendigkeit haengt bewusst NICHT an der gemessenen
                 Inhaltsbreite: .p-menubar-end waechst in den freien Platz und
                 .header-actions richtet seine Kinder darin rechts aus (SCSS).
                 Vorgeschichte: das Kundenlogo ging mit 0px in die intrinsische
                 Breite ein (max-height statt definiter Hoehe, s. .customer-logo im
                 SCSS) – die Gruppe wurde um dessen Breite zu schmal bemessen und
                 margin-left:auto schob Glocke/Avatar aus dem Viewport. -->
            <div class="header-actions">

            <!-- Kundenlogo: steht links vom Tertiary-Menue. Gibt es kein
                 Tertiary-Menue, rueckt es automatisch an das Glocken-Icon heran –
                 der Abstand nach rechts (.customer-logo margin-right) entspricht
                 dem zwischen Glocke und Avatar.
                 Erst ab Desktop-Breite (> 1024px); bis einschliesslich Tablet fehlt
                 im Header der Platz (siehe showCustomerLogo in der Komponente). -->
            @if (showCustomerLogo() && customerLogo()) {
                <img
                    class="customer-logo"
                    [src]="customerLogo()"
                    [alt]="customerName()" />
            }

            @for (menuItem of tertiaryMenuItems; track menuItem.baseUrl) {
                <div>
                    <!-- Icon-Quelle: `cssClasses`, sonst `image` (resolveTertiaryIcon).
                         In der DB steht in beiden Feldern mal eine Icon-Klasse
                         ("fa-regular fa-messages"), mal eine Bild-URL
                         (".../grow-icons/feather/${theme}/State_Default.svg") --
                         welcher Fall vorliegt, entscheidet isImageIcon().

                         Bewusst <p-button> statt <button pButton>: nur die KOMPONENTE
                         hat einen Icon-Slot, in dem auch ein <img> stehen kann. Der Slot
                         greift ausschliesslich, wenn `icon` NICHT gesetzt ist
                         (PrimeNG-Bedingung `!icon && iconTemplate`) -- deshalb hier kein
                         [icon]. `styleClass` statt `class`, damit die Klasse am inneren
                         <button> landet, auf dem das SCSS aufsetzt (.p-button). -->
                    @let tertiaryIcon = resolveTertiaryIcon(menuItem);
                    <p-button
                        class="navigation-menu-icon-host"
                        styleClass="navigation-menu-icon-button"
                        [ariaLabel]="menuItem.text"
                        [pTooltip]="menuItem.text"
                        tooltipPosition="bottom"
                        (onClick)="onClickTertiaryMenuItem(menuItem.baseUrl)">
                        <ng-template pTemplate="icon">
                            @if (isImageIcon(tertiaryIcon)) {
                                <!-- alt="": der zugaengliche Name steht am Button (ariaLabel). -->
                                <img class="navigation-menu-icon-image" [src]="tertiaryIcon" alt="" />
                            } @else {
                                <span class="p-button-icon" [ngClass]="tertiaryIcon" aria-hidden="true"></span>
                            }
                        </ng-template>
                    </p-button>
                </div>
            }
 
            <button pButton #bellButton class="navigation-menu-icon-button"
                icon="fa-regular fa-bell"
                pBadge
                [value]="unreadNotificationsCount()"
                [badgeDisabled]="unreadNotificationsCount() === 0"
                badgeSize="small"
                [attr.aria-label]="unreadNotificationsCount() > 0
                    ? ('redesign.header.NOTIFICATIONS.UNREAD' | translate: { count: unreadNotificationsCount() })
                    : ('redesign.header.NOTIFICATIONS.LABEL' | translate)"
                [attr.aria-haspopup]="'dialog'"
                [attr.aria-expanded]="notificationsPopover.overlayVisible"
                [pTooltip]="'redesign.header.NOTIFICATIONS.LABEL' | translate"
                tooltipPosition="bottom"
                (click)="notificationsPopover.toggle($event)"></button>

            <!-- Statusmeldung (WCAG 4.1.3): kündigt Änderungen der ungelesenen
                 Anzahl an, ohne den Fokus zu verschieben. Bei 0 leer -> keine Ansage. -->
            <span class="visually-hidden" role="status" aria-live="polite">
                @if (unreadNotificationsCount() > 0) {
                    {{ 'redesign.header.NOTIFICATIONS.UNREAD' | translate: { count: unreadNotificationsCount() } }}
                }
            </span>

                <!-- -->
            <p-popover
                #notificationsPopover
                appendTo="body"
                styleClass="my-custom-popover"
                [dismissable]="true"
                [autoZIndex]="true"
                [baseZIndex]="10000"
                [showCloseIcon]="false"
                [focusOnShow]="false"
                [ariaLabel]="'redesign.header.NOTIFICATIONS.LABEL' | translate"
                [style]="{'min-height': '200px'}"
                (onShow)="onPopoverShow(notificationsPopover, bellButton)"
                (onHide)="onPopoverHide(bellButton)">
                <ng-template pTemplate="content">
                    <!-- cdkTrapFocus: Tab/Shift+Tab zykliert im Popover; Verlassen via
                         Escape (schließt + Fokus zurück) oder Outside-Click. Ohne
                         AutoCapture – Fokus-in/-zurück steuern onPopoverShow/-Hide. -->
                    <div class="custom-popover-content" cdkTrapFocus>

                        <sx-notifications
                            [data]="notifications()"
                            (setNotificationRead)="onSetNotificationRead($event)"
                            [debug]="debug">
                        </sx-notifications>

                    </div>
                </ng-template>
            </p-popover>

            <button
                type="button" 
                pButton 
                class="p-button-text p-button-rounded user-button"
                (click)="menu.toggle($event)" 
                [pTooltip]="userName" 
                tooltipPosition="bottom" 
                [attr.aria-label]="userName"
                >
                <div class="user-icon">
                    <p-avatar [image]="userData?.imageBase64" shape="circle" size="large" aria-hidden="true"></p-avatar>
                </div>
            </button>

            <!-- (onShow): rechnet das an <body> angehaengte Panel auf Viewport-
                 Koordinaten um, damit es beim Scrollen am fixed Header stehen
                 bleibt (s. onUserMenuShow in der Komponente). -->
            <p-menu #menu [model]="userInfo" [popup]="true" appendTo="body" [tabindex]="0"
                (onShow)="onUserMenuShow(menu)">

                <ng-template pTemplate="submenuheader" let-item>
                    <div class="py-2" [style]="{'display': 'flex', 'flex-direction': 'column', 'gap': '4px'}">            
                        <span class="text-base font-bold text-gray-800">
                            {{ item.label }}
                        </span>
                        
                        @if (item.state?.subLabel) {
                            <span class="text-sm text-gray-500">
                                {{ item.state?.subLabel }}
                            </span>
                        }
                        
                    </div>
                </ng-template>

                <ng-template pTemplate="item" let-item>
                    @if (item.state?.isButton) {
                            <!--
                                onClick wird im p-menu behandelt und löst das item.command aus! Das verhindert das der Event 2 mal kommt und ermöglicht, dass das Menu sauber geschlossen wird.
                                (onClick)="$event.stopPropagation(); item.command ? item.command({originalEvent: $event, item: item}) : null"

                                fluid=true können wir nicht verwenden, da wir in scss ein margin gesetzt haben und fluid das nicht berücksichtigt.
                            -->
                            <p-button
                                [label]="item.label"
                                [ariaLabel]="item.ariaLabel"
                                [icon]="item.icon"
                                [styleClass]="(item.styleClass || '') + ' p-menu-user-info'"
                                >
                            </p-button>
                    } @else {
                        <a
                            [href]="item.url || '#'"
                            class="p-menuitem-link"
                            [attr.aria-label]="item.ariaLabel"
                            (click)="item.command ? item.command({originalEvent: $event, item: item}) : null">
                            @if (item.icon) {
                                <span [class]="item.icon"></span>
                            }
                            <span class="p-menuitem-text">{{ item.label }}</span>
                        </a>
                    }
                </ng-template>
            </p-menu>

            </div><!-- /.header-actions -->

        </ng-template>
    </p-menubar>
</div>

